import React, { useEffect, useRef } from 'react';

const IntroStats = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('opacity-100', 'translate-y-0', 'translate-x-0', 'scale-100');
          entry.target.classList.remove('opacity-0', 'translate-y-7', '-translate-x-9');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    if (containerRef.current) {
      const children = containerRef.current.querySelectorAll('.reveal-element');
      children.forEach(child => observer.observe(child));
    }

    return () => observer.disconnect();
  }, []);

  const cards = [
    { title: 'Design', desc: 'Engineering-Driven Innovation', delay: 'delay-100' },
    { title: 'Manufacture', desc: 'Precision at Every Stage', delay: 'delay-200' },
    { title: 'Quality', desc: 'Tested for Reliability', delay: 'delay-300' },
    { title: 'Support', desc: 'Partnership Beyond Delivery', delay: 'delay-400' },
  ];

  return (
    <section ref={containerRef} className="bg-cogLight text-cogInk py-12 sm:py-16 lg:py-20 overflow-hidden font-sans">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-8 sm:gap-10 lg:gap-14 items-center">

          {/* Left Block */}
          <div className="reveal-element opacity-0 -translate-x-9 transition-all duration-700 ease-out">
            <h2 className="font-display font-bold text-xl sm:text-2xl md:text-3xl lg:text-4xl text-cogBrand leading-[1.15] mb-4 sm:mb-6 lg:mb-8 tracking-tight max-w-2xl">
              A Partner For Long Run
            </h2>
            <p className="text-sm sm:text-base text-cogInk/75 leading-relaxed mt-2 sm:mt-4">
              At PVS Harness Solutions, we believe successful partnerships are built on trust, quality, and consistency. By combining engineering expertise with dependable manufacturing, we support our customers with reliable wiring harness solutions from development through production and beyond.
            </p>
          </div>

          {/* Right Metrics Grid */}
          <div className="grid grid-cols-2 gap-3 sm:gap-4 md:gap-6">
            {cards.map((card) => (
              <div
                key={card.title}
                className={`reveal-element opacity-0 translate-y-7 transition-all duration-700 ease-out ${card.delay} bg-cogLight rounded-lg p-4 sm:p-5 md:p-6 shadow-sm border border-cogInk/5 min-w-0 overflow-hidden`}
              >
                <p
                  className="font-display font-bold text-cogCyan break-words hyphens-auto leading-tight"
                  style={{ fontSize: 'clamp(1.125rem, 2vw, 2.25rem)' }}
                >
                  {card.title}
                </p>
                <p className="text-xs sm:text-sm text-cogInk/70 mt-1 leading-snug break-words">
                  {card.desc}
                </p>
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
};

export default IntroStats;